/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import ParticipantHasNewVersionsModal from './participant.has.new.versions.component';
import { hideModal } from '../../actions/actions';
import { openAddNewDocumentModal } from '../../actions/participant.status.actions';

export const mapStateToProps = (state, ownProps) => {
  return {};
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    openAddNewDocumentModal: () => {
      dispatch(openAddNewDocumentModal());
    },
    closeModal: () => {
      dispatch(hideModal());
    }
  };
};

const ParticipantHasNewDocumentsModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ParticipantHasNewVersionsModal);

export default ParticipantHasNewDocumentsModalContainer;
